var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3969 13.6771V63.6457H63.5099V13.6771H13.3969ZM11.8428 12.1274H65.0639V65.1952H11.833V12.1177L11.8428 12.1274Z",
    fill: "#0D0B0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7652 1L1 38.6563L38.7652 76.3127L76.5302 38.6563L38.7652 1Z",
    fill: "url(#paint0_linear_338_335)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7652 1L1 38.6563L38.7652 76.3127L76.5302 38.6563L38.7652 1Z",
    fill: "url(#paint1_linear_338_335)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5694 29.2056L38.7877 23.7192L33.9419 29.2056L38.7877 31.9914L43.5694 29.2056Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7878 34.7599L50.769 27.8521L48.4277 37.4626L55.6039 33.3513L51.5983 49.519L44.3814 53.5934L48.4277 37.4626L38.7878 42.9941L29.1554 37.4729L33.1494 53.5934L26.0229 49.519L21.9268 33.3525L29.1554 37.4729L26.7483 27.7969L38.7878 34.7599Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_338_335",
    x1: 1,
    y1: 38.6563,
    x2: 76.4566,
    y2: 38.7445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "#EE8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#38DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_338_335",
    x1: 1,
    y1: 38.6563,
    x2: 76.4566,
    y2: 38.7445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497815,
    stopColor: "#EE8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#38DEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.1aa1e8c58e560e4f5db3b5de0d823d5b.svg";
export { ForwardRef as ReactComponent };